import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Banner from "./components/Banner";
import Home from "./components/Home"; 
import Services from "./components/Services"; 
import Footer from "./components/Footer";
import AboutUs from "./components/AboutUs";
import Careers from "./components/Careers";
import Contact from "./components/Contact";

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <div className="spacing">
                <Banner />
              </div>
              <div className="container mt-5">
                <Home /> 
              </div>
            </>
          }
        />
        <Route
          path="/home"
          element={
            <>
              <div className="spacing">
                <Banner />
              </div>
              <div className="container mt-5">
                <Home />
              </div>
            </>
          }
        />
        <Route path="/services" element={<Services />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
